<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Get Paid More and Promoted Faster</title>
<link href="CSS_1.css" rel="stylesheet" type="text/css"/>
<div class="dedication" id="d14e196">
<p id="d7e3196"><br/><br/><br/> This book is dedicated to my good friend and business partner, Victor Risling, a man who exemplifies the finest qualities of commitment, dedication, responsibility, and the willingness to always go the extra mile to get the job done. Victor is the ultimate role model for anyone who truly wants to get paid more and promoted faster.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?44b95c11